import axios from "axios";
import { JWTDecode } from '@/utils/common'

const user = localStorage.getItem('token') && JWTDecode(localStorage.getItem('token'));
const initialState = user
    ? { currentUser: user }
    : { currentUser: null };

const state = {
  currentUser: initialState.currentUser,
  isAuth: false,
};

const mutations = {
  SET_AUTH_STATE_CHANGEL (state, payload) {
    if (payload) {
      localStorage.setItem('token', payload)
      const userData = JWTDecode(payload)
      state.currentUser = userData;
    } else {
      localStorage.removeItem('token')
      // remove the axios default header
      delete axios.defaults.headers.common['Authorization']
      state.currentUser = {}
    }
  }
}

const actions = {
  ON_AUTH_STATE_CHANGEL({ commit }, data) {
    commit("SET_AUTH_STATE_CHANGEL", data);
  }
};

const getters = {
  currentUser: state => state.currentUser
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
